var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4995 4.37397L9.88086 3.75534L10.4995 3.13672L11.1181 3.75534L10.4995 4.37397ZM11.3745 12.249C11.3745 12.481 11.2823 12.7036 11.1182 12.8677C10.9541 13.0318 10.7315 13.124 10.4995 13.124C10.2674 13.124 10.0449 13.0318 9.88077 12.8677C9.71667 12.7036 9.62448 12.481 9.62448 12.249H11.3745ZM5.50586 8.13034L9.88086 3.75534L11.1181 4.99259L6.74311 9.36759L5.50586 8.13034ZM11.1181 3.75534L15.4931 8.13034L14.2559 9.36759L9.88086 4.99259L11.1181 3.75534ZM11.3745 4.37397V12.249H9.62448V4.37397H11.3745Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 14V14.875C4.375 15.3391 4.55937 15.7842 4.88756 16.1124C5.21575 16.4406 5.66087 16.625 6.125 16.625H14.875C15.3391 16.625 15.7842 16.4406 16.1124 16.1124C16.4406 15.7842 16.625 15.3391 16.625 14.875V14",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.b1553a24d9363e184eb9ae48d87e2eea.svg";
export { ForwardRef as ReactComponent };